export default {"src":"/_next/static/media/ProfileDetails.4ab68ca6.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};